// extracted by mini-css-extract-plugin
export default {"link":"style_link__o5sBX","link__active":"style_link__active__qlLwO"};